
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const skumetadataApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listSKUMetadatas: builder.query ({
      query: (params) => `v2/skumetadata/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUMetadata"]
    }),
    getSKUMetadata: builder.query ({
      query: (skumetadata_id) => `v2/skumetadata/${skumetadata_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUMetadata"]
    }),

    updateSKUMetadata: builder.mutation ({
      query: ({skumetadata_id, data}) => ({
        url: `v2/skumetadata/${skumetadata_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["SKUMetadata"]
    }),
    deleteSKUMetadata: builder.mutation ({
      query: (skumetadata_id) => ({
        url: `v2/skumetadata/${skumetadata_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["SKUMetadata"]
    }),
    createSKUMetadata: builder.mutation ({
      query: (data) => ({
        url: `v2/skumetadata/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SKUMetadata"]
    }),
  })
})


export const {
  useListSKUMetadatasQuery,
  useLazyListSKUMetadatasQuery,
  useGetSKUMetadataQuery,
  useLazyGetSKUMetadataQuery,

  useUpdateSKUMetadataMutation,
  useDeleteSKUMetadataMutation,
  useCreateSKUMetadataMutation
} = skumetadataApi
